<template>
    <v-badge :color="count > 0 ? 'green' : 'error'" inline dot></v-badge>
</template>


<script>
export default {
    name: 'StockDot',
    props: {
        count: Number,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>